import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "svg-container" }
const _hoisted_2 = {
  viewBox: "0 0 1400 850",
  xmlns: "http://www.w3.org/2000/svg",
  class: "network-topology"
}
const _hoisted_3 = { class: "layer proxmox-layer" }
const _hoisted_4 = {
  x: "700",
  y: "60",
  class: "layer-title"
}
const _hoisted_5 = {
  x: "700",
  y: "80",
  class: "layer-subtitle"
}
const _hoisted_6 = {
  x: "700",
  y: "100",
  class: "layer-detail"
}
const _hoisted_7 = { class: "node k3s-master" }
const _hoisted_8 = {
  x: "290",
  y: "210",
  class: "node-title"
}
const _hoisted_9 = {
  x: "290",
  y: "230",
  class: "node-detail"
}
const _hoisted_10 = {
  x: "290",
  y: "250",
  class: "node-detail"
}
const _hoisted_11 = {
  x: "290",
  y: "270",
  class: "node-detail"
}
const _hoisted_12 = { class: "node k3s-master" }
const _hoisted_13 = {
  x: "700",
  y: "210",
  class: "node-title"
}
const _hoisted_14 = {
  x: "700",
  y: "230",
  class: "node-detail"
}
const _hoisted_15 = {
  x: "700",
  y: "250",
  class: "node-detail"
}
const _hoisted_16 = {
  x: "700",
  y: "270",
  class: "node-detail"
}
const _hoisted_17 = { class: "node k3s-master" }
const _hoisted_18 = {
  x: "1110",
  y: "210",
  class: "node-title"
}
const _hoisted_19 = {
  x: "1110",
  y: "230",
  class: "node-detail"
}
const _hoisted_20 = {
  x: "1110",
  y: "250",
  class: "node-detail"
}
const _hoisted_21 = {
  x: "1110",
  y: "270",
  class: "node-detail"
}
const _hoisted_22 = { class: "service kube-vip" }
const _hoisted_23 = {
  x: "700",
  y: "370",
  class: "service-title"
}
const _hoisted_24 = {
  x: "700",
  y: "390",
  class: "service-detail"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", _hoisted_2, [
      _createElementVNode("g", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("rect", {
          x: "560",
          y: "30",
          width: "280",
          height: "100",
          rx: "12",
          class: "layer-bg",
          fill: "var(--ln-glass-elevated)",
          stroke: "var(--ln-teal-deep)",
          "stroke-width": "3"
        }, null, -1)),
        _createElementVNode("text", _hoisted_4, _toDisplayString(_ctx.$t('homelab.svg.proxmoxTitle')), 1),
        _createElementVNode("text", _hoisted_5, _toDisplayString(_ctx.$t('homelab.svg.proxmoxSubtitle')), 1),
        _createElementVNode("text", _hoisted_6, _toDisplayString(_ctx.$t('homelab.svg.proxmoxDetail')), 1)
      ]),
      _createElementVNode("g", _hoisted_7, [
        _cache[1] || (_cache[1] = _createElementVNode("rect", {
          x: "200",
          y: "180",
          width: "180",
          height: "110",
          rx: "10",
          class: "node-bg",
          fill: "var(--ln-glass-surface)",
          stroke: "var(--ln-teal-light)",
          "stroke-width": "2.5"
        }, null, -1)),
        _createElementVNode("text", _hoisted_8, _toDisplayString(_ctx.$t('homelab.svg.master')) + " 1", 1),
        _createElementVNode("text", _hoisted_9, _toDisplayString(_ctx.$t('homelab.svg.etcd')), 1),
        _createElementVNode("text", _hoisted_10, _toDisplayString(_ctx.$t('homelab.svg.apiServer')), 1),
        _createElementVNode("text", _hoisted_11, _toDisplayString(_ctx.$t('homelab.svg.controller')), 1)
      ]),
      _createElementVNode("g", _hoisted_12, [
        _cache[2] || (_cache[2] = _createElementVNode("rect", {
          x: "610",
          y: "180",
          width: "180",
          height: "110",
          rx: "10",
          class: "node-bg",
          fill: "var(--ln-glass-surface)",
          stroke: "var(--ln-teal-light)",
          "stroke-width": "2.5"
        }, null, -1)),
        _createElementVNode("text", _hoisted_13, _toDisplayString(_ctx.$t('homelab.svg.master')) + " 2", 1),
        _createElementVNode("text", _hoisted_14, _toDisplayString(_ctx.$t('homelab.svg.etcd')), 1),
        _createElementVNode("text", _hoisted_15, _toDisplayString(_ctx.$t('homelab.svg.apiServer')), 1),
        _createElementVNode("text", _hoisted_16, _toDisplayString(_ctx.$t('homelab.svg.controller')), 1)
      ]),
      _createElementVNode("g", _hoisted_17, [
        _cache[3] || (_cache[3] = _createElementVNode("rect", {
          x: "1020",
          y: "180",
          width: "180",
          height: "110",
          rx: "10",
          class: "node-bg",
          fill: "var(--ln-glass-surface)",
          stroke: "var(--ln-teal-light)",
          "stroke-width": "2.5"
        }, null, -1)),
        _createElementVNode("text", _hoisted_18, _toDisplayString(_ctx.$t('homelab.svg.master')) + " 3", 1),
        _createElementVNode("text", _hoisted_19, _toDisplayString(_ctx.$t('homelab.svg.etcd')), 1),
        _createElementVNode("text", _hoisted_20, _toDisplayString(_ctx.$t('homelab.svg.apiServer')), 1),
        _createElementVNode("text", _hoisted_21, _toDisplayString(_ctx.$t('homelab.svg.controller')), 1)
      ]),
      _createElementVNode("g", _hoisted_22, [
        _cache[4] || (_cache[4] = _createElementVNode("rect", {
          x: "530",
          y: "340",
          width: "340",
          height: "70",
          rx: "10",
          class: "service-bg",
          fill: "var(--ln-glass-elevated)",
          stroke: "var(--ln-teal-deep)",
          "stroke-width": "3"
        }, null, -1)),
        _createElementVNode("text", _hoisted_23, _toDisplayString(_ctx.$t('homelab.svg.kubeVipTitle')), 1),
        _createElementVNode("text", _hoisted_24, _toDisplayString(_ctx.$t('homelab.svg.kubeVipDetail')), 1)
      ]),
      _cache[5] || (_cache[5] = _createStaticVNode("<g class=\"service metallb\" data-v-2d78e53f><rect x=\"950\" y=\"340\" width=\"240\" height=\"70\" rx=\"10\" class=\"service-bg\" fill=\"var(--ln-glass-surface)\" stroke=\"var(--ln-stone-grey)\" stroke-width=\"2.5\" data-v-2d78e53f></rect><text x=\"1070\" y=\"365\" class=\"service-title\" data-v-2d78e53f>MetalLB</text><text x=\"1070\" y=\"385\" class=\"service-detail\" data-v-2d78e53f>L2 Load Balancing</text><text x=\"1070\" y=\"400\" class=\"service-detail\" data-v-2d78e53f>IP Pool</text></g><g class=\"service traefik\" data-v-2d78e53f><rect x=\"950\" y=\"440\" width=\"240\" height=\"90\" rx=\"10\" class=\"service-bg\" fill=\"var(--ln-glass-elevated)\" stroke=\"var(--ln-teal-deep)\" stroke-width=\"3\" data-v-2d78e53f></rect><text x=\"1070\" y=\"470\" class=\"service-title\" data-v-2d78e53f>Traefik Ingress</text><text x=\"1070\" y=\"490\" class=\"service-detail\" data-v-2d78e53f>MetalLB IP</text><text x=\"1070\" y=\"510\" class=\"service-detail\" data-v-2d78e53f>→ Internet</text></g><g class=\"monitoring-stack\" data-v-2d78e53f><rect x=\"50\" y=\"480\" width=\"340\" height=\"200\" rx=\"12\" class=\"layer-bg\" fill=\"var(--ln-glass-base)\" stroke=\"var(--ln-terracotta-subtle)\" stroke-width=\"3\" data-v-2d78e53f></rect><text x=\"220\" y=\"510\" class=\"layer-title\" data-v-2d78e53f>Monitoring</text><rect x=\"70\" y=\"535\" width=\"300\" height=\"40\" rx=\"6\" class=\"service-mini\" fill=\"var(--ln-glass-elevated)\" stroke=\"var(--ln-terracotta-subtle)\" data-v-2d78e53f></rect><text x=\"220\" y=\"560\" class=\"service-mini-text\" data-v-2d78e53f>Prometheus</text><rect x=\"70\" y=\"590\" width=\"300\" height=\"40\" rx=\"6\" class=\"service-mini\" fill=\"var(--ln-glass-elevated)\" stroke=\"var(--ln-terracotta-subtle)\" data-v-2d78e53f></rect><text x=\"220\" y=\"615\" class=\"service-mini-text\" data-v-2d78e53f>Grafana</text><rect x=\"70\" y=\"645\" width=\"300\" height=\"40\" rx=\"6\" class=\"service-mini\" fill=\"var(--ln-glass-elevated)\" stroke=\"var(--ln-terracotta-subtle)\" data-v-2d78e53f></rect><text x=\"220\" y=\"670\" class=\"service-mini-text\" data-v-2d78e53f>Loki</text></g><g class=\"cicd-stack\" data-v-2d78e53f><rect x=\"430\" y=\"480\" width=\"340\" height=\"200\" rx=\"12\" class=\"layer-bg\" fill=\"var(--ln-glass-base)\" stroke=\"var(--ln-teal-light)\" stroke-width=\"3\" data-v-2d78e53f></rect><text x=\"600\" y=\"510\" class=\"layer-title\" data-v-2d78e53f>CI/CD &amp; GitOps</text><rect x=\"450\" y=\"535\" width=\"300\" height=\"40\" rx=\"6\" class=\"service-mini\" fill=\"var(--ln-glass-elevated)\" stroke=\"var(--ln-teal-light)\" data-v-2d78e53f></rect><text x=\"600\" y=\"560\" class=\"service-mini-text\" data-v-2d78e53f>GitLab CI/CD</text><rect x=\"450\" y=\"590\" width=\"300\" height=\"40\" rx=\"6\" class=\"service-mini\" fill=\"var(--ln-glass-elevated)\" stroke=\"var(--ln-teal-light)\" data-v-2d78e53f></rect><text x=\"600\" y=\"615\" class=\"service-mini-text\" data-v-2d78e53f>ArgoCD</text><rect x=\"450\" y=\"645\" width=\"300\" height=\"40\" rx=\"6\" class=\"service-mini\" fill=\"var(--ln-glass-elevated)\" stroke=\"var(--ln-teal-light)\" data-v-2d78e53f></rect><text x=\"600\" y=\"670\" class=\"service-mini-text\" data-v-2d78e53f>Registry</text></g><g class=\"apps-layer\" data-v-2d78e53f><rect x=\"810\" y=\"570\" width=\"380\" height=\"110\" rx=\"12\" class=\"layer-bg\" fill=\"var(--ln-glass-base)\" stroke=\"var(--ln-stone-grey)\" stroke-width=\"3\" data-v-2d78e53f></rect><text x=\"1000\" y=\"600\" class=\"layer-title\" data-v-2d78e53f>Applications</text><circle cx=\"880\" cy=\"645\" r=\"25\" class=\"app-icon\" fill=\"var(--ln-glass-elevated)\" stroke=\"var(--ln-teal-deep)\" stroke-width=\"2\" data-v-2d78e53f></circle><text x=\"880\" y=\"652\" class=\"app-icon-text\" data-v-2d78e53f>WA</text><circle cx=\"970\" cy=\"645\" r=\"25\" class=\"app-icon\" fill=\"var(--ln-glass-elevated)\" stroke=\"var(--ln-teal-deep)\" stroke-width=\"2\" data-v-2d78e53f></circle><text x=\"970\" y=\"652\" class=\"app-icon-text\" data-v-2d78e53f>DB</text><circle cx=\"1060\" cy=\"645\" r=\"25\" class=\"app-icon\" fill=\"var(--ln-glass-elevated)\" stroke=\"var(--ln-teal-deep)\" stroke-width=\"2\" data-v-2d78e53f></circle><text x=\"1060\" y=\"652\" class=\"app-icon-text\" data-v-2d78e53f>API</text><circle cx=\"1150\" cy=\"645\" r=\"25\" class=\"app-icon\" fill=\"var(--ln-glass-elevated)\" stroke=\"var(--ln-teal-deep)\" stroke-width=\"2\" data-v-2d78e53f></circle><text x=\"1150\" y=\"652\" class=\"app-icon-text\" data-v-2d78e53f>...</text></g><g class=\"storage-layer\" data-v-2d78e53f><rect x=\"50\" y=\"720\" width=\"560\" height=\"110\" rx=\"12\" class=\"layer-bg\" fill=\"var(--ln-glass-base)\" stroke=\"var(--ln-stone-grey)\" stroke-width=\"3\" data-v-2d78e53f></rect><text x=\"330\" y=\"750\" class=\"layer-title\" data-v-2d78e53f>Distributed Storage</text><rect x=\"70\" y=\"775\" width=\"240\" height=\"45\" rx=\"6\" class=\"service-mini\" fill=\"var(--ln-glass-elevated)\" stroke=\"var(--ln-stone-grey)\" data-v-2d78e53f></rect><text x=\"190\" y=\"803\" class=\"service-mini-text\" data-v-2d78e53f>Longhorn CSI</text><rect x=\"350\" y=\"775\" width=\"240\" height=\"45\" rx=\"6\" class=\"service-mini\" fill=\"var(--ln-glass-elevated)\" stroke=\"var(--ln-stone-grey)\" data-v-2d78e53f></rect><text x=\"470\" y=\"803\" class=\"service-mini-text\" data-v-2d78e53f>HA Replication</text></g><g class=\"security-layer\" data-v-2d78e53f><rect x=\"650\" y=\"720\" width=\"540\" height=\"110\" rx=\"12\" class=\"layer-bg\" fill=\"var(--ln-glass-base)\" stroke=\"var(--ln-terracotta-hover)\" stroke-width=\"3\" data-v-2d78e53f></rect><text x=\"920\" y=\"750\" class=\"layer-title\" data-v-2d78e53f>Security &amp; Network</text><rect x=\"680\" y=\"775\" width=\"230\" height=\"45\" rx=\"6\" class=\"service-mini\" fill=\"var(--ln-glass-elevated)\" stroke=\"var(--ln-terracotta-hover)\" data-v-2d78e53f></rect><text x=\"795\" y=\"803\" class=\"service-mini-text\" data-v-2d78e53f>Cert-Manager</text><rect x=\"940\" y=\"775\" width=\"230\" height=\"45\" rx=\"6\" class=\"service-mini\" fill=\"var(--ln-glass-elevated)\" stroke=\"var(--ln-terracotta-hover)\" data-v-2d78e53f></rect><text x=\"1055\" y=\"803\" class=\"service-mini-text\" data-v-2d78e53f>Network Policies</text></g><line x1=\"700\" y1=\"130\" x2=\"290\" y2=\"180\" class=\"connection\" stroke=\"var(--ln-teal-deep)\" stroke-width=\"2.5\" stroke-dasharray=\"6,4\" data-v-2d78e53f><animate attributeName=\"stroke-dashoffset\" from=\"0\" to=\"10\" dur=\"1s\" repeatCount=\"indefinite\" data-v-2d78e53f></animate></line><line x1=\"700\" y1=\"130\" x2=\"700\" y2=\"180\" class=\"connection\" stroke=\"var(--ln-teal-deep)\" stroke-width=\"2.5\" stroke-dasharray=\"6,4\" data-v-2d78e53f><animate attributeName=\"stroke-dashoffset\" from=\"0\" to=\"10\" dur=\"1s\" repeatCount=\"indefinite\" data-v-2d78e53f></animate></line><line x1=\"700\" y1=\"130\" x2=\"1110\" y2=\"180\" class=\"connection\" stroke=\"var(--ln-teal-deep)\" stroke-width=\"2.5\" stroke-dasharray=\"6,4\" data-v-2d78e53f><animate attributeName=\"stroke-dashoffset\" from=\"0\" to=\"10\" dur=\"1s\" repeatCount=\"indefinite\" data-v-2d78e53f></animate></line><line x1=\"290\" y1=\"290\" x2=\"630\" y2=\"340\" class=\"connection\" stroke=\"var(--ln-teal-light)\" stroke-width=\"2\" data-v-2d78e53f></line><line x1=\"700\" y1=\"290\" x2=\"700\" y2=\"340\" class=\"connection\" stroke=\"var(--ln-teal-light)\" stroke-width=\"2\" data-v-2d78e53f></line><line x1=\"1110\" y1=\"290\" x2=\"770\" y2=\"340\" class=\"connection\" stroke=\"var(--ln-teal-light)\" stroke-width=\"2\" data-v-2d78e53f></line><line x1=\"1110\" y1=\"235\" x2=\"1070\" y2=\"340\" class=\"connection\" stroke=\"var(--ln-stone-grey)\" stroke-width=\"2\" data-v-2d78e53f></line><line x1=\"1070\" y1=\"410\" x2=\"1070\" y2=\"440\" class=\"connection\" stroke=\"var(--ln-teal-deep)\" stroke-width=\"3\" data-v-2d78e53f></line><line x1=\"1070\" y1=\"530\" x2=\"1000\" y2=\"570\" class=\"connection\" stroke=\"var(--ln-teal-deep)\" stroke-width=\"2\" data-v-2d78e53f></line>", 16))
    ]))
  ]))
}